import React from 'react';
import { Box, Typography } from '@mui/material';
import MessagingPanel from '../../messaging/MessagingPanel';
import { theme } from '../../../theme';

const MessagingPage = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 3, color: theme.colors.text.primary }}>
        Messagerie
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Gérez les conversations avec les responsables de salon. Tous les admins et superadmins peuvent voir les conversations, 
        mais seul l'admin attribué reçoit les notifications de nouveaux messages.
      </Typography>
      <MessagingPanel />
    </Box>
  );
};

export default MessagingPage;
